export interface AuditRef {
  id: number;
  label: string | null;
}

export type AuditFieldChange =
  | { old: unknown; new: unknown }
  | { added: AuditRef[]; removed: AuditRef[] };

export interface AuditSnapshot {
  fields: Record<string, unknown>;
  collections: Record<string, AuditRef[]>;
  deleted: boolean;
  companyId: number | null;
}

export interface AuditLogEntry {
  id: number;
  createdAt: string;
  entityType: string;
  entityId: number;
  action: "create" | "update" | "delete";
  actorType: string;
  actorId: number | null;
  actorEmail: string | null;
  companyId: number | null;
  changes: Record<string, AuditFieldChange> | null;
  snapshot: AuditSnapshot | null;
  source: string | null;
  ip: string | null;
}

export interface AuditLogFilters {
  entityType: string | null;
  entityId: string;
  companyId: string;
  action: string | null;
  actorType: string | null;
  actorEmail: string;
  fromDate: Date | null;
  toDate: Date | null;
}

export const EMPTY_AUDIT_LOG_FILTERS: AuditLogFilters = {
  entityType: null,
  entityId: "",
  companyId: "",
  action: null,
  actorType: null,
  actorEmail: "",
  fromDate: null,
  toDate: null,
};
